var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationOffice = function SvgLocationOffice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3B3F44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.714,
    clipPath: "url(#location-office_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.762 2.714H3.048A1.714 1.714 0 0 0 1.333 4.43v18.857h17.143V19M5.619 7.857h3.428M5.619 13h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.19 18.143H8.62a.857.857 0 0 0-.857.857v3.429c0 .473.383.857.857.857h2.571a.857.857 0 0 0 .857-.857V19a.857.857 0 0 0-.857-.857Zm12.429-12c0 2.846-5.143 9.428-5.143 9.428s-5.143-6.582-5.143-9.428a5.143 5.143 0 1 1 10.286 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.476 7a.857.857 0 1 0 0-1.714.857.857 0 0 0 0 1.714"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "location-office_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.333 0h24v24h-24z"
  })))));
};
export default SvgLocationOffice;